import {format} from 'date-fns';
import {track} from '@common-web/lib/analytics';

export function downloadCsvFile(csv: string, filename: string) {
  const blob = new Blob(['\ufeff', csv], {type: 'text/csv;charset=utf-8;'});
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
  track('csv_downloaded', {path: window.location.pathname});
}

export function makeCsvFilename(prefix: string) {
  return `${prefix}-${format(new Date(), 'yyyy-MM-dd')}.csv`;
}
